import { render } from "./Qr.vue?vue&type=template&id=31f6d3ee&bindings={\"value\":\"data\",\"size\":\"data\"}"
import script from "./Qr.vue?vue&type=script&lang=js"
export * from "./Qr.vue?vue&type=script&lang=js"
script.render = render

export default script